export const TAB_TITLES = {
  DISCOVER: 'Discover',
  BRAND: 'Brand',
};
